import { BrowserRouter, Routes, Route } from "react-router";
import { LandingLayout } from "./screens/landing/layout";
import { DashboardLayout } from "./screens/dashboard/layout";
import { SessionProvider } from "./services/auth0/session";
import LandingScreen from "./screens/landing/landing.screen";
import DashboardScreen from "./screens/dashboard/dashboard.screen";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Auth0ProviderWithNavigate } from "./services/auth0/auth";
import { useSocketSetup } from "@/services/socket.io/useSocketSetup";
import OrdersScreen from "./screens/tables/orders.screen";
import OperatorsScreen from "./screens/tables/operators.screen";
import DepotsScreen from "./screens/tables/depots.screen";
import ServiceAreasScreen from "./screens/tables/service-areas.screen";
import PricingsScreen from "./screens/tables/pricings.screen";
import OrdersTableScreen from "./screens/tables/orders.screen";
import TasksScreen from "./screens/tables/tasks.screen";
import CustomersScreen from "./screens/tables/customers.screen";
import { TableLayout } from "./screens/tables/layout";
import InvoicesScreen from "./screens/tables/invoices.screen";
import TripsScreen from "./screens/tables/trips.screen";
import AddressMediasScreen from "./screens/tables/address-medias.screen";
import { GoogleMapsApiProvider } from "./services/maps/google-maps-api-provider";
import TagsScreen from "./screens/tables/tags.screen";
import { Toaster } from "@/components/ui/toaster";
import AnalyticsDashboard from "./features/analytics/analytics-dashboard";

const queryClient = new QueryClient();

const SocketProvider = ({ children }: { children: React.ReactNode }) => {
  useSocketSetup({ closeOnUnmount: true });
  return <>{children}</>;
};

export const Router = () => {
  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools />
        <Toaster />
        <Auth0ProviderWithNavigate>
          <SessionProvider>
            <SocketProvider>
              <GoogleMapsApiProvider>
                <Routes>
                  <Route element={<LandingLayout />}>
                    <Route path="/" element={<LandingScreen />} />
                  </Route>
                  <Route element={<DashboardLayout />}>
                    <Route path="/dashboard" element={<DashboardScreen />} />
                  </Route>
                  <Route element={<TableLayout />}>
                    <Route path="/orders" element={<OrdersScreen />} />
                    <Route path="/operators" element={<OperatorsScreen />} />
                    <Route path="/depots" element={<DepotsScreen />} />
                    <Route
                      path="/service-areas"
                      element={<ServiceAreasScreen />}
                    />
                    <Route path="/pricings" element={<PricingsScreen />} />
                    <Route
                      path="/orders-table"
                      element={<OrdersTableScreen />}
                    />
                    <Route path="/tasks" element={<TasksScreen />} />
                    <Route path="/customers" element={<CustomersScreen />} />
                    <Route path="/invoices" element={<InvoicesScreen />} />
                    <Route path="/trips" element={<TripsScreen />} />
                    <Route
                      path="/address-medias"
                      element={<AddressMediasScreen />}
                    />
                    <Route path="/tags" element={<TagsScreen />} />
                    <Route path="/analytics" element={<AnalyticsDashboard />} />
                  </Route>
                </Routes>
              </GoogleMapsApiProvider>
            </SocketProvider>
          </SessionProvider>
        </Auth0ProviderWithNavigate>
      </QueryClientProvider>
    </BrowserRouter>
  );
};
